import { HttpXsrfTokenExtractor } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_VERSION, API_VERSION_HEADER } from './api-version-interceptor';

@Injectable({
  providedIn: 'root',
})
export class UnloadReleaseService {
  private readonly xsrfTokenExtractor = inject(HttpXsrfTokenExtractor);

  release(url: string): void {
    const headers = new Headers();
    headers.append(API_VERSION_HEADER, API_VERSION);
    const xsrfToken = this.xsrfTokenExtractor.getToken();
    if (xsrfToken) {
      headers.append('X-XSRF-TOKEN', xsrfToken);
    }
    fetch(url, { method: 'GET', keepalive: true, credentials: 'include', headers }).catch(error => console.error('Could not release the lock while the page was closing', error));
  }
}
